import React from "react";
import { useSelector } from "react-redux";
import Support from "logistic-integrations/components/Support";
import { useTranslation } from "react-i18next";

function SliderSupport() {
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);
  const { t } = useTranslation();
  return (
    <Support
      orderNo={
        orderInfo?.logisticPartnerMetadata?.SLIDER?.createDeliveryResponse
          ?.order_number
      }
      phone="+971 52 732 5000"
      heading={t("Slider Order Number")}
      heading2={t("Slider Helpline Number")}
    />
  );
}

export default SliderSupport;
